import IconHide from '@/components/assets/icon_hide.svg'
import IconShow from '@/components/assets/icon_show.svg'
import { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSlotHide } from '@/components/ui/input-otp'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { ComponentProps, ForwardedRef, useState } from 'react'

type ViverseInputOTPProps = Omit<ComponentProps<typeof InputOTP>, 'children' | 'ref' | 'render'> & {
  maxLength: number
  hasError?: boolean
  defaultHidden?: boolean
  ref?: ForwardedRef<HTMLInputElement>
}

function ViverseInputOTP({
  maxLength,
  hasError,
  defaultHidden = false,
  ref,
  ...props
}: ViverseInputOTPProps) {
  const t = useTranslations()
  const [isHide, setIsHide] = useState(defaultHidden)

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row items-center gap-2">
        <InputOTP
          ref={ref}
          {...props}
          maxLength={maxLength}
          // allow only all digits or all asterisks
          pattern="^(\d+|\*+)$"
          containerClassName="w-max"
        >
          <InputOTPGroup className="gap-2">
            {Array.from({ length: maxLength }, (_, index) => (
              <div key={index}>
                {isHide ? (
                  <InputOTPSlotHide
                    key={index}
                    index={index}
                    className={cn(
                      'header-4 bg-vive-primary-70 ring-vive-border-focus h-[34px] w-7 rounded-[5px] text-[18px] text-white backdrop-blur-[20px] md:h-12 md:w-10 md:text-[24px]',
                      hasError && 'border-vive-error border-[1.5px]',
                    )}
                    dotClassName={cn('md:h-3 md:w-3 h-2 w-2')}
                    caretClassName="bg-white"
                  />
                ) : (
                  <InputOTPSlot
                    key={index}
                    index={index}
                    className={cn(
                      'header-4 bg-vive-primary-70 ring-vive-border-focus h-[34px] w-7 rounded-[5px] text-[18px] text-white backdrop-blur-[20px] md:h-12 md:w-10 md:text-[24px]',
                      hasError && 'border-vive-error border-[1.5px]',
                    )}
                    caretClassName="bg-white"
                  />
                )}
              </div>
            ))}
          </InputOTPGroup>
        </InputOTP>
        <div className="cursor-pointer" onClick={() => setIsHide((prev) => !prev)}>
          {isHide ? <IconHide /> : <IconShow />}
        </div>
      </div>

      {hasError && (
        <div className="body-4">
          {t('profile-page.my-worlds-card-settings-passcode-caption', {
            count: maxLength,
          })}
        </div>
      )}
    </div>
  )
}

export default ViverseInputOTP
